// extracted by mini-css-extract-plugin
module.exports = {"errorBox":"PL","tbt":"QL","table":"RL","subTotal":"SL","orderTotal":"TL","value":"UL","label":"VL","noGcMsg":"WL"};